// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__7NgvE","importantInfo":"styles_importantInfo__2eqcA"};